import { NewContentLoadedEvent } from '../events/new-content-loaded';

export function initContactButtons( selectors: Array<string>, container: Document | HTMLElement = document ): void {
    function initBtn( btn: HTMLButtonElement ): void {
        btn.addEventListener( 'click', () => {
            let url: URL;

            if ( btn.dataset.actionRoute ) {
                url = new URL( window.location.origin + btn.dataset.actionRoute );
            } else {
                url = new URL( window.location.href );
            }

            url.pathname += '/contact';

            btn.dispatchEvent( new CustomEvent( 'twc:manual-navigation', {
                bubbles: true,
                detail: {
                    url: url.toString(),
                    isRoutedPopup: true,
                    additionalParams: btn.dataset.actionParams || '',
                    events: {
                        open: [ btn.dataset.actionOpenEvents ],
                    },
                },
            } ) );
        } );
    }

    container.querySelectorAll<HTMLElement>( selectors.join( ',' ) ).forEach( ( btn: HTMLButtonElement ) => {
        initBtn( btn );
    } );

    window.addEventListener( 'twc:newcontentloaded', ( event: CustomEvent<NewContentLoadedEvent> ) => {
        ( event.detail.container || document ).querySelectorAll<HTMLElement>( selectors.join( ',' ) ).forEach( ( btn: HTMLButtonElement ) => {
            initBtn( btn );
        } );
    } );
}
